export default __webpack_public_path__ + "static/media/down.72ee9cb9.svg";